import React from 'react';
import styles from './CountryThirdSection.module.css';
import one from '../../assets/images/one.svg';
import two from '../../assets/images/two.svg';
import three from '../../assets/images/three.svg';

export default function CountryThirdSection() {

    const data = [
        {
            image: one,
            heading: "Select the visa type",
            des: "Complete your purchase using a payment method of your choice.",
        },
        {
            image: two,
            heading: "Upload your documents",
            des: "Upload soft copy of below mentioned documents and get your visa.",
        },
        {
            image: three,
            heading: "Get Your Visa",
            des: "Keep track of your visa status and get visa on mail.",
        },
    ]

    return (
        <div className={styles.main}>
            <h1 className={styles.heading}>Visa application process</h1>
            {data.map((value, index)=>(
                <div className={styles.box} key={index}>
                <img src={value.image} alt="123" />
                <div className={styles.lef}>
                    <h1 className={styles.lefHead}>{value.heading}</h1>
                    <p className={styles.lefDes}>{value.des}</p>
                </div>
            </div>
            ))}
            
        </div>
    )
}
